import React, { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { Textfit } from 'react-textfitfix'; // or react-textfit if you're using that

interface ScoreNumberProps {
  value: number | string;
  size: string;
  weight: number;
  spacing?: string | undefined;
  animationClass?: string;
}

export const ScoreText: React.FC<ScoreNumberProps> = ({
  value,
  size,
  weight,
  spacing,
  animationClass = 'fade-in',
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const previousValue = useRef(value);

  useEffect(() => {
    if (value !== previousValue.current && ref.current) {
      const el = ref.current;
      el.classList.remove(animationClass);
      // Trigger reflow to restart animation
      void el.offsetWidth;
      el.classList.add(animationClass);
    }
    previousValue.current = value;
  }, [value, animationClass]);

  return (
    <Box ref={ref} sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
        
      <Typography variant="h1" fontFamily={"Thungten"} letterSpacing={spacing} fontSize={size} fontWeight={weight}>{value}</Typography>
    </Box>
  );
};
